import React from 'react';
import { withRouter } from 'react-router-dom'
import "./Profile.css";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import Swal from 'sweetalert2'
import axios from 'axios';
import FileBase64 from 'react-file-base64';

import { API_MOSA_URL, ACCESS_TOKEN_NAME } from '../constants/apiContants';
import LoadingOverlay from 'react-loading-overlay';

const devicedetails = {
  "imei": "862188038288320",
  "deviceOSVersion": "6.0.1",
  "uuid": "862188038288320",
  "deviceModel": "NOKIA 100",
  "deviceManufacturer": "Xiaomi",
  "serviceProvider": "airtel",
  "deviceOS": "ANDROID",
  "ipAddress": "192.168.43.210"
}
const headers = {
  "RequestMode": "0",
  "UserID": localStorage.getItem('userid'),
  "BearerKey": "Mobile",
  "ServiceId": "SERV!",
  "SessionId": localStorage.getItem(ACCESS_TOKEN_NAME),
  "Locale": "E/A",
  "DeviceDet": devicedetails

}
class MyAccount extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        isActive: false
    };

}

componentDidMount() {
  console.log("UST************** "+localStorage.getItem("usertype"));
  if(localStorage.getItem("usertype")!="User")
  {
    window.scrollTo(0, 0);

    let self = this; //  declared var welcom

    this.setState({ isActive: true });
    const mosa = { ReqHead: headers }
    console.log(JSON.stringify(mosa));


    axios.post(API_MOSA_URL + '/Company/GetMyEventList', mosa)

      .then(function (response) {
        console.log(JSON.stringify(response.data));
        // self.redirectToValidate();
        self.setState({ isActive: false });

        if (response.status === 200) {

          if (response.data[0].StatusCode == "0") {

            self.setState({ locations: response.data[1] });
            window.scrollTo(0, 0);

          } else {
            Swal.fire({
              title: 'Error!',
              text: response.data[0].Message,
              icon: 'error',
              confirmButtonText: 'Ok'
            })
          }

        } else {
          Swal.fire({
            title: 'Error!',
            text: 'Please try again later!',
            icon: 'error',
            confirmButtonText: 'Ok'
          })
        }

      })
      .catch(function (error) {
        console.log(error);
        self.setState({ isActive: false });
        Swal.fire({
          title: 'Error!',
          text: 'Please try again later!',
          icon: 'error',
          confirmButtonText: 'Ok'
        })

      });
    }else{
      this.props.history.push('/welcome');

    }

  }

  render() {
    return (
      <LoadingOverlay
        active={this.state.isActive}
        spinner
        text='Loading ...'
      >
        <div>
          <Navbar page={5} />
          <div className="all-title-box">
            <div className="container text-center">
              <h1>My Account<span className="m_1">View your Membership Status and Requests</span></h1>
            </div>
          </div>


          <Footer />
        </div>
      </LoadingOverlay>
    )
  }
}
export default withRouter(MyAccount);
